import { ProductPayment } from '../types/transactionTypes';
import { formatCurrency } from '@/lib';

export function TransactionPaymentPlanDetails({ paymentData }: { paymentData: ProductPayment }) {
    const successfulPayments = paymentData.payment_plan_data?.successful_payments;
    const totalPayments = paymentData.data.total_payments;
    const paymentPlanStatus = paymentData.payment_plan_status;
    const status = paymentPlanStatus ? (paymentPlanStatus === 1 ? 'Active' : 'Cancelled') : 'Completed';

    const totalAmountOwing = formatCurrency(
        (paymentData.payment_plan_data?.price?.duration ?? 1) * (paymentData?.pos_data?.gross_amount?.value ?? 1),
        paymentData?.pos_data?.net_amount?.currency ?? 'USD'
    );

    const amountPaid = formatCurrency(
        (paymentData.payment_plan_data?.successful_payments ?? 0) * (paymentData?.pos_data?.gross_amount?.value ?? 1),
        paymentData?.pos_data?.net_amount?.currency ?? 'USD'
    );
    return (
        <div className='flex w-full flex-col flex-wrap items-center gap-4 md:flex-row md:items-start md:gap-7'>
            <div className='flex w-full flex-col flex-wrap gap-4 md:flex-grow md:flex-row md:gap-7'>
                <div className='flex w-full items-start gap-3 md:w-fit md:flex-col'>
                    <div className='text-gray text-sm font-semibold'>Payments Made</div>
                    <div className='ml-auto md:ml-0'>
                        {successfulPayments} of {totalPayments}
                    </div>
                </div>

                <div className='md:border-l-neutral-main flex w-full items-start gap-3 border-l-0 p-0 md:w-fit md:flex-col md:border-l-1 md:pl-5'>
                    <div className='text-gray text-sm font-semibold'>Status</div>
                    <div className='ml-auto md:ml-0'>{status}</div>
                </div>

                <div className='md:border-l-neutral-main flex w-full items-start gap-3 border-l-0 p-0 md:w-fit md:flex-col md:border-l-1 md:pl-5'>
                    <div className='text-gray text-sm font-semibold'>Total Amount</div>
                    <div className='ml-auto md:ml-0'>{totalAmountOwing}</div>
                </div>

                <div className='md:border-l-neutral-main flex w-full items-start gap-3 border-l-0 p-0 md:w-fit md:flex-col md:border-l-1 md:pl-5'>
                    <div className='text-gray text-sm font-semibold'>Paid</div>
                    <div className='ml-auto md:ml-0'>{amountPaid}</div>
                </div>
            </div>
        </div>
    );
}
